import { customRequest } from '@/api/ref'
import axios from 'axios'
import { apiInfo } from './ajax'

function complete (r) {
  try {
    // 拿服务器时间，计算时间差，保存到本地。
    let serverTime = r.getResponseHeader ? r.getResponseHeader('server_time') : Date.now()
    if (serverTime) {
      serverTime = (Number(serverTime) || 0) + 1000 // 加1秒接口返回的补差
      const localTime = new Date().getTime() // 获取得到本地时间戳
      const serverTimeStamp = serverTime // 获取时间戳
      const timeDiff: any = localTime - serverTimeStamp
      localStorage.setItem('serverTimeDiff', timeDiff)
    }
  } catch (err) {
    console.log(err)
  }
}

/**
 * mock请求
 * @param url
 * @param data
 */
export function mockData (url: string, params: any = null) {
  axios('/mock/' + url + '.json').then(_res => {
    if (_res) {
      const res: any = {
        Success: true,
        Code: '1001',
        data: _res.data
      }
      params && params.success && params.success(res)
      complete(res)
      params && params.complete && params.complete(res)
    }
  })
}

/**
 * 统一处理接口请求
 * @param opt
 */
export function checkRef (opt: any) {
  const procParams = opt && opt.procParams
  if (procParams) {
    return customRequest
  } else {
    const url = opt && opt.url
    if (url && url.indexOf('http') === -1) {
      const _url = url.replace('../', '/').split('?')[0]
      return apiInfo[_url]
    }
  }
  return false
}

/**
 * ajax接口请求转换
 * 包含两种
 * 1、newAjax请求的统一接口
 * 2、.net尚未迁移的ajax接口
 * @param opt
 * @param params
 */
export function apiFetch (opt: any, params: any) {
  const _method: any = checkRef(opt)
  if (_method) {
    if (typeof _method === 'string') {
      if (_method === 'default') {
        console.log(opt.procParams, opt.data)
      } else if (_method === 'ajax') {
        // warning 此处出现日志，证明接口没有适配，需要进行适配
        console.error('接口未适配', opt.url, opt.data)
      } else {
        mockData(opt.procParams.N, params)
      }
    } else {
      if (opt.url && opt.url.indexOf('?') > -1) {
        const _arr = opt.url.split('?')
        params.urlParam = _arr[1]
      }
      opt.beforeSend && opt.beforeSend()
      _method(opt.data, params).then(res => {
        const _dataInfo = res.data || {}
        let _res: any = {
          Success: true,
          Code: '1001',
          ..._dataInfo
        }
        if (opt.url) {
          _res = res.data
        }
        params && params.success && params.success(_res)
        complete(_res)
        params && params.complete && params.complete(res)
      })
    }
  }
}
